import React from 'react'
import PropTypes from 'prop-types'
import AppleLogin from 'react-apple-login'

import { IconApple } from '../../Icons/IconApple'
import environment from '../../../environment'

function LoginAppleButton(props) {
    const { state, onSucess, handleRemove, onError, isModal, t } = props

    const handleAppleResponse = (res) => {
        if(res?.authorization?.id_token) {
            onSucess(res?.authorization?.id_token)
        } else {
            onError('')
        }
    }
    return (
        !isModal ? <div className="flex flex-col justify-center items-center gap-5" >
            <IconApple className="w-[20px]" />
            {
                !state && <AppleLogin
                    clientId={environment.APPLE_CLIENT_ID}
                    redirectURI={environment.APPLE_CALL_BACK_URL}
                    usePopup={true}
                    callback={handleAppleResponse}
                    responseMode="query"
                    scope="email name"
                    render={renderProps => (
                        <button className="border border-solid border-black/[0.1] rounded-[5px] bg-white h-[30px] min-w-[72px]  px-1 lg:w-[85px] text-center text-black text-xs" onClick={renderProps.onClick}>{t('Connect')}</button>
                    )}
                />
            }
            {
                state && <button className="border border-solid border-black/[0.1] rounded-[5px] bg-white h-[30px] min-w-[72px]  px-1 lg:w-[85px] text-center text-suzu-error text-xs" onClick={() => handleRemove()}>{t('title.disconnect')}</button>
            }
        </div >: <div className="flex flex-row justify-start  items-center gap-[10px] lg:gap-[15px]" >
            <IconApple className="w-[20px]" />
            <AppleLogin
                    clientId={environment.APPLE_CLIENT_ID}
                    redirectURI={environment.APPLE_CALL_BACK_URL}
                    usePopup={true}
                    callback={handleAppleResponse}
                    responseMode="query"
                    scope="email name"
                    render={renderProps => (
                        <button className=" px-1 text-center text-black text-xs" onClick={renderProps.onClick}>
                            <span className="text-black text-[14px]">
                            {t("title_connect_apple_account")}
                            </span>
                        </button>
                    )}
            />
        </div>
    )
}
LoginAppleButton.propTypes = {
    state: PropTypes.string,
    onSucess: PropTypes.func,
    handleRemove: PropTypes.func
}

export default LoginAppleButton

